module.exports = __webpack_public_path__ + "img/about_con_1-2.e127d3be.png";